// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MileageSarathi_bg_screen__ivshM {
    background-color: #f1f2fb
}

.MileageSarathi_tabs__BfHBM {
    /* background-color: white; */
    /* border-radius: 5px */
    margin: 0.7rem
}

.MileageSarathi_tab_bar__PRmqF {
    border-bottom: #83a4cf 4px solid !important;
    border-radius: 2px !important;
    color: #83a4cf !important;
}

.MileageSarathi_nav_bar_buttons__yuDsE {
    background-color: transparent;
    border: none;
    font-weight: 800;
    font-size: 14px;
    color: gray
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/MileageSarathi.module.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf;AACJ","sourcesContent":[".bg_screen {\n    background-color: #f1f2fb\n}\n\n.tabs {\n    /* background-color: white; */\n    /* border-radius: 5px */\n    margin: 0.7rem\n}\n\n.tab_bar {\n    border-bottom: #83a4cf 4px solid !important;\n    border-radius: 2px !important;\n    color: #83a4cf !important;\n}\n\n.nav_bar_buttons {\n    background-color: transparent;\n    border: none;\n    font-weight: 800;\n    font-size: 14px;\n    color: gray\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg_screen": `MileageSarathi_bg_screen__ivshM`,
	"tabs": `MileageSarathi_tabs__BfHBM`,
	"tab_bar": `MileageSarathi_tab_bar__PRmqF`,
	"nav_bar_buttons": `MileageSarathi_nav_bar_buttons__yuDsE`
};
export default ___CSS_LOADER_EXPORT___;
